import { PartialBlock } from "@blocknote/core";
import { proxy } from "valtio/vanilla";
import { fileTypes, FileTypeSettings } from "src/js/stores/editor/fileTypes";
import { FILE_DEFAULT_NAME } from "./fileTypes";

export type EditorStore = {
  showWorkbench: boolean;
  siteId?: string;
  siteTitle: string;
  showPreview: boolean;
  localFileContents: PartialBlock[];
  savedFileContents?: PartialBlock[];
  isSaved: boolean;
  fileType: FileTypeSettings;
  fileName: string;
  fileAction: "new" | "edit" | "delete";
  generationInput?: string;
};

export const getInitialEditorStore = () =>
  ({
    showWorkbench: true,
    siteId: undefined,
    siteTitle: "",
    showPreview: false,
    localFileContents: [],
    savedFileContents: undefined,
    isSaved: true,
    fileType: fileTypes.general,
    fileName: FILE_DEFAULT_NAME,
    fileAction: "new",
    generationInput: undefined,
  } as EditorStore);

export const editorStore = proxy<EditorStore>(getInitialEditorStore());
